import React, {Component} from 'react';
import Slider from "react-slick";
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {Image, Row} from 'react-bootstrap';

import {copy_into_saved_design} from '../Dashboard/actions'
import {fetch_user_details} from '../../components/loginModal/actions';

import './style.css';


function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className="slick-arrow slick-next"
            // style={{ ...style, display: "block", background: "red" }}
            onClick={onClick}
        >
            <i style={{'width': '20px', 'height': '20px', 'color': '#333333'}} className="fas fa-lg fa-angle-right"></i>
        </div>
    );
}
  

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className="slick-arrow slick-prev"
            // style={{ ...style, display: "block", background: "red" }}
            onClick={onClick}
        >
            <i style={{'width': '20px', 'height': '20px', 'color': '#333333'}} className="fas fa-lg fa-angle-left"></i>
        </div>
    );
}


const settings = {
    slidesToShow: 1,
    slidesToScroll : 5,
    variableWidth: true,
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
};

class Categories extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            all_categories: [],
            redirect: false,
            redirect_url: null,
        }
    }

    componentDidMount() {
        console.log("history", this.props);
        this.refresh_data();    
    }

    refresh_data = async () => {
        try {
            var url = global.config.server_path + 'category/fetch_all_design_categories';
            var resp = await fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({})});
            resp = await resp.json();
            var all_categories = resp.data;
            this.setState({all_categories});
        } catch(err) {
            console.log(err);
        }
    }

    MyLoader = props => (
        <div style={{backgroundColor:'#f1f2f3',width: props.width ? props.width : '100%', height: props.height ? props.height : '100%', zIndex: '-2000', position: 'absolute', bottom: 35, left:0, right:0, marginLeft: 'auto', marginRight: 'auto', maxWidth:160, maxHeight: 185}}>
            
        </div>
    )

    design_template_on_click = (template, category) => {
        // var apply_brand_kit = (template.apply_brand_kit?'?abk='+encodeURIComponent(1):'');
        var category_name = category ? '?category=' + encodeURIComponent(category._id) : '';

        this.props.copy_into_saved_design(template._id)
        .then(copied_design => {
            this.redirect_page('/designmaker/start/designs/'+ copied_design._id+'/edit'+category_name) 
        })
        .catch(err => Promise.reject(err))
    }

    category_carousel = () => {

        return this.state.all_categories.sort((a, b) => (a.priority < b.priority ? 1 : -1)).map(current_category => (
            <div>
                <Row style={{'fontWeight': 'bold', 'marginTop': '25px', 'marginBottom':'20px'}}>
                    <span style={{fontFamily: 'Montserrat', fontWeight: 800, fontSize: 22}}>{current_category.name}</span>
                </Row>
                <Row style={{'marginTop': '10px', marginBottom: 10}}>
                    <div style={{'paddingLeft': '5px', 'paddingRight': '5px'}}>
                        <Slider className="dashboard-horizontal-scroll-component" className="slick_shadow" {...settings}>
                            {current_category.children && current_category.children.sort((a, b) => (a.priority <= b.priority ? 1 : -1)).filter(x => x.example).map((element, idx) => 
                                <div key={idx} className="template_slide_container_dashboard">
                                    <this.MyLoader height={(element.example.design_file.height / element.example.design_file.width) > 1 ? 185 : 160 * (element.example.design_file.height / element.example.design_file.width)} width={(element.example.design_file.width / element.example.design_file.height) > 1 ? 160 : 185 * (element.example.design_file.width / element.example.design_file.height)} />
                                    <Image style={{bottom: 35, boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)', left:0, right:0, marginLeft: 'auto', marginRight: 'auto', position: 'absolute', cursor: 'pointer', maxWidth: 160, objectFit: 'contain', maxHeight: 185}} key={'horizonal-scroll-tempates'+idx} onClick={() => {this.design_template_on_click(element.example, element)}} src={(element.example.thumbnail.indexOf('data:image')>-1 || element.example.thumbnail.indexOf('http')>-1 || element.example.thumbnail.indexOf('blob:')>-1)?(element.example.thumbnail):(global.config.static_file_server_path+ element.example.thumbnail+'?t='+Date.now())} alt={'Image Not Found'}/>
                                    <h6 style={{position: 'absolute', bottom: 0, width: '100%', textAlign: 'center'}}><b>{element.name}</b></h6>
                                </div>
                            )}    
                        </Slider>
                    </div>
                </Row>
            </div>
        ))
    }


    redirect_page = (url) => {
        this.setState({redirect_url:url,redirect:true})
    }

    render() {
        var {redirect, redirect_url} = this.state;
        
        if (redirect) {
            return (<Redirect push to={redirect_url} />)
        }

        return (
            <div style={{paddingTop: 30, paddingRight: '30px', 'paddingLeft': '5px'}}>
                    <div style={{fontWeight: 'bold', fontSize: 12, cursor: 'pointer',zIndex:'500',position:'relative'}} onClick={() => this.redirect_page('/designmaker/start')}><span className="fas fa-chevron-left" /> Back </div>
                    {(this.state.all_categories && this.state.all_categories.length) ? (<this.category_carousel />) : (<div></div>)}   
            </div>
        )
    }

}


const mapStateToProps = function(state, own_props) {
    return {
        user: state.user,
        ...own_props
    }
}


const mapDispatchToProps = dispatch => ({
    fetch_user_details: dispatch(fetch_user_details()),
    copy_into_saved_design: (id) => dispatch(copy_into_saved_design(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Categories);